(function () {
  const sectionSelector = '[data-fill-collection-section]';
  const openDrawerSelector = '[data-fill-collection-open-drawer]';
  const closeDrawerSelector = '[data-fill-collection-close-drawer]';
  const drawerSelector = '[data-fill-collection-drawer]';
  const focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])',
    'summary'
  ].join(',');

  const initialized = new WeakSet();

  function getFocusable(container) {
    return Array.from(container.querySelectorAll(focusableSelector)).filter((element) => {
      return element instanceof HTMLElement && element.offsetParent !== null;
    });
  }

  function setAccordionState(section) {
    section.querySelectorAll('.fill-collection__filter-group').forEach((details) => {
      const summary = details.querySelector('summary');
      if (!summary) return;
      summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
    });
  }

  function openDrawer(section, opener) {
    const drawer = section.querySelector(drawerSelector);
    if (!(drawer instanceof HTMLElement)) return;

    section._fillCollectionLastFocus = opener;
    drawer.hidden = false;
    document.body.classList.add('fill-collection-drawer-open');
    opener?.setAttribute('aria-expanded', 'true');

    const focusable = getFocusable(drawer);
    (focusable[0] || drawer).focus();
  }

  function closeDrawer(section) {
    const drawer = section.querySelector(drawerSelector);
    if (!(drawer instanceof HTMLElement) || drawer.hidden) return;

    drawer.hidden = true;
    document.body.classList.remove('fill-collection-drawer-open');
    section.querySelectorAll(openDrawerSelector).forEach((button) => button.setAttribute('aria-expanded', 'false'));

    const lastFocus = section._fillCollectionLastFocus;
    if (lastFocus instanceof HTMLElement) {
      lastFocus.focus();
    }
  }

  function trapFocus(event, section) {
    if (event.key !== 'Tab') return;
    const drawer = section.querySelector(drawerSelector);
    if (!(drawer instanceof HTMLElement) || drawer.hidden) return;

    const focusable = getFocusable(drawer);
    if (focusable.length === 0) {
      event.preventDefault();
      drawer.focus();
      return;
    }

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function setQuickAddState(button, state) {
    if (!(button instanceof HTMLButtonElement)) return;

    if (state) {
      button.dataset.fillCollectionState = state;
      button.setAttribute('aria-busy', state === 'loading' ? 'true' : 'false');
    } else {
      delete button.dataset.fillCollectionState;
      button.removeAttribute('aria-busy');
    }
  }

  function initialize(section) {
    if (!(section instanceof HTMLElement) || initialized.has(section)) return;
    initialized.add(section);

    setAccordionState(section);

    section.addEventListener('toggle', (event) => {
      if (event.target instanceof HTMLDetailsElement && event.target.classList.contains('fill-collection__filter-group')) {
        const summary = event.target.querySelector('summary');
        summary?.setAttribute('aria-expanded', event.target.open ? 'true' : 'false');
      }
    }, true);

    section.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      const opener = target?.closest(openDrawerSelector);
      const closer = target?.closest(closeDrawerSelector);

      if (opener instanceof HTMLElement) {
        openDrawer(section, opener);
      }

      if (closer) {
        closeDrawer(section);
      }
    });

    section.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeDrawer(section);
        return;
      }

      trapFocus(event, section);
    });

    section.addEventListener('change', (event) => {
      const target = event.target;
      if (target instanceof HTMLSelectElement && target.matches('[data-fill-collection-sort]')) {
        target.form?.submit();
      }
    });

    section.addEventListener('submit', (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      const addButton = form.querySelector('.fill-collection-card__quick-control--add');
      if (!(addButton instanceof HTMLButtonElement)) return;

      if (addButton.disabled) {
        event.preventDefault();
        return;
      }

      setQuickAddState(addButton, 'loading');
      addButton.disabled = true;

      window.setTimeout(() => {
        addButton.disabled = false;
        if (addButton.dataset.added === 'true') {
          setQuickAddState(addButton, 'added');
          window.setTimeout(() => setQuickAddState(addButton, null), 900);
        } else {
          setQuickAddState(addButton, null);
        }
      }, 1800);
    });

    document.addEventListener('shopify:cart:lines-update', () => {
      section.querySelectorAll('.fill-collection-card__quick-control--add[data-fill-collection-state]').forEach((button) => {
        if (!(button instanceof HTMLButtonElement)) return;
        button.disabled = false;
        setQuickAddState(button, 'added');
        window.setTimeout(() => setQuickAddState(button, null), 900);
      });
    });
  }

  function initializeAll(root) {
    root.querySelectorAll(sectionSelector).forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(document));
  } else {
    initializeAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeAll(event.target);
  });
})();
